import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { TextRenderer } from 'APP/components/TextRenderer/TextRenderer';
import { MiniatureMessageLayout } from 'APP/main/ChatView/components/MiniatureMessageLayout/MiniatureMessageLayout';

import styles from './styles.m.scss';

const Text = ({
  titleClassName,
  textClassName,
  iconClassName,
  message,
  title,
  onClick,
  preventInteraction,
}) => {
  const { text, linkPreview } = message.payload;

  if (!message) {
    return null;
  }

  return (
    <MiniatureMessageLayout
      titleClassName={titleClassName}
      iconClassName={iconClassName}
      title={title}
      messageId={message.id}
      onClick={onClick}
      imageUrl={linkPreview?.image?.url}
      preventInteraction={preventInteraction}
    >
      <TextRenderer
        isPlainText
        className={classNames(styles.text, textClassName)}
      >
        {text}
      </TextRenderer>
    </MiniatureMessageLayout>
  );
};

export default observer(Text);
